<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.container {
  background: #03006c;
}

.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg_4.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div class="container" ref="contianer" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;display: flex;flex-direction: column;">
    <div ref="header" class="yongxinBigTitle" style="height:66px;width:100%;display: flex;justify-content: center;align-items: center;color: white;font-weight: bold;font-size: 30px;">
      <p>原材料综合看板</p>
    </div>
    <div style="flex:1;display: flex;justify-content: space-between;width: 100%;padding-bottom: 20px;">
      <div class="biankuang" style="width: 40%;margin-top: 20PX;" ref="tableContainer">
        <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
          <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
            集中供料信息
          </div>
        </div>
        <div :style="{ height: contentHeight + 'px' }" style="padding: 0px 16px;">
          <el-table ref="table" class="monitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
            <el-table-column :label="$t('料斗')">
              <template slot-scope="scope">
                <div style="font-size: 14px;font-weight: bold;">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column :label="$t('当前烘料温度℃')">
              <template slot-scope="scope">
                <div style="font-size: 14px;font-weight: bold;">
                  {{ scope.row.temperature }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('当前累计料重kg')">
              <template slot-scope="scope">
                <div style="font-size: 14px;font-weight: bold;">
                  {{ scope.row.currentFeedWeight != null ? scope.row.currentFeedWeight.toFixed(2) : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('当班累计料重kg')">
              <template slot-scope="scope">
                <div style="font-size: 14px;font-weight: bold;">
                  {{ scope.row.shiftFeedWeight != null ? scope.row.shiftFeedWeight.toFixed(2) : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('历史累计料重kg')">
              <template slot-scope="scope">
                <div style="font-size: 14px;font-weight: bold;">
                  {{ scope.row.totalFeedWeight != null ? scope.row.totalFeedWeight.toFixed(1) : '' }}
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
      <div style="width: 60%;;flex-shrink: 0;box-sizing: border-box;display: grid; grid-template-columns: 1fr 1fr ;grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr  ;grid-gap: 10px;padding: 20px;padding-bottom: 0px;height: 100%;">
        <div class="biankuang" v-for="(item, i) in list2" style="background: #03006c;display: flex;flex-direction: column;height: 100%;">
          <div style="display: flex;justify-content: space-around;align-items: center;flex: 1;">

            <p style="color: rgb(255, 200, 58);font-weight:bold;font-size: 22px;">{{ item.name }}</p>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div>
                <span style="font-size:32px;font-weight: bold;color: white;">{{ item.shiftFeedWeight != null ? item.shiftFeedWeight.toFixed(2) : '-' }}</span><span style="font-size:22px;font-weight: bold;color: white;">kg</span>
              </div>
              <p style="color: rgb(103, 190, 89);font-weight:bold;font-size: 18px;margin-top: 10px;">{{ $t('当班累计料重') }}</p>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;">
              <div>
                <span style="font-size:32px;font-weight: bold;color: white;">{{ item.totalFeedWeight != null ? item.totalFeedWeight.toFixed(1) : '-' }}</span><span style="font-size:22px;font-weight: bold;color: white;">kg</span>
              </div>
              <p style="color: rgb(103, 190, 89);font-weight:bold;font-size: 18px;margin-top: 10px;">{{ $t('历史累计料重') }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_customize_yongxin_monitor_mes_liaodou_index',
  components: {},
  watch: {
  },
  data() {
    return {
      timer: null,
      list: [],
      contentHeight: 0,
      rowHeight: 0,
      list2: [],
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/report/raw_material/list', {});
      this.list = response.data.lineList;
      this.list2 = response.data.cardList;


      console.log(this.list2)
      // this.list2 = response2.data;


    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.tableContainer) {
          return;
        }
        this.contentHeight = this.$refs.tableContainer.offsetHeight - this.$refs.titleBar.offsetHeight - 20;
        console.log(this.contentHeight)
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;

      }, 800);
    }
  }
};
</script>
